const modernNavigationMap = {
    navigate: 'navigation',
    reload: 'refresh',
};
const legacyNavigationMap = {
    0: 'navigation',
    1: 'refresh',
};
const getModernNavigationType = (entryType) => {
    return modernNavigationMap[entryType] || 'alternative';
};
const getLegacyNavigationType = (entryType) => {
    return legacyNavigationMap[entryType] || 'alternative';
};
const getNavigationType = () => {
    const [navigationEntry] = window.performance.getEntriesByType('navigation');
    if (navigationEntry) {
        return getModernNavigationType(navigationEntry.type);
    }
    if (performance.navigation?.type !== undefined) {
        return getLegacyNavigationType(performance.navigation.type);
    }
    return 'unknown';
};
export { getNavigationType };
//# sourceMappingURL=get-navigation-type.js.map